var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bold/Calling"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calling"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    d: "M12.0153 4.57512C11.6186 4.50184 11.2542 4.755 11.1787 5.14224C11.1032 5.52947 11.3571 5.90754 11.743 5.98332C12.9049 6.20984 13.8021 7.10922 14.0295 8.27508V8.27592C14.0942 8.61152 14.3897 8.85552 14.7299 8.85552C14.7756 8.85552 14.8212 8.85135 14.8677 8.84303C15.2536 8.76558 15.5076 8.38834 15.432 8.00027C15.0926 6.25897 13.7523 4.91406 12.0153 4.57512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    d: "M11.9634 1.6736C11.7775 1.64695 11.5908 1.70191 11.4422 1.82017C11.2895 1.94008 11.1941 2.1133 11.1733 2.30733C11.1293 2.69956 11.4123 3.05432 11.8041 3.09846C14.5054 3.39991 16.6051 5.5043 16.9089 8.21411C16.9495 8.57719 17.2541 8.85117 17.6176 8.85117C17.645 8.85117 17.6716 8.84951 17.699 8.84617C17.889 8.82536 18.0583 8.73125 18.1778 8.58136C18.2965 8.43146 18.3504 8.24492 18.3289 8.05422C17.9504 4.67321 15.3337 2.04918 11.9634 1.6736Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Call"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49073 9.97731C12.815 13.3006 13.5691 9.45592 15.6857 11.571C17.7262 13.611 18.899 14.0197 16.3136 16.6043C15.9898 16.8645 13.9323 19.9955 6.70145 12.7667C-0.530286 5.53699 2.59893 3.47736 2.85925 3.15362C5.45083 0.561864 5.8525 1.74148 7.89302 3.78143C10.0096 5.8974 6.16649 6.654 9.49073 9.97731Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalling);
export default __webpack_public_path__ + "static/media/calling.71ab6cff5b6151d5521536d65f23fc5b.svg";
export { ForwardRef as ReactComponent };